import { render, staticRenderFns } from "./sys_work_logs_detail.vue?vue&type=template&id=54b537a9&scoped=true"
import script from "./sys_work_logs_detail.vue?vue&type=script&lang=js"
export * from "./sys_work_logs_detail.vue?vue&type=script&lang=js"
import style0 from "./sys_work_logs_detail.vue?vue&type=style&index=0&id=54b537a9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b537a9",
  null
  
)

export default component.exports